import { render, staticRenderFns } from "./MusicButtons.vue?vue&type=template&id=55661063&"
import script from "./MusicButtons.vue?vue&type=script&lang=js&"
export * from "./MusicButtons.vue?vue&type=script&lang=js&"
import style0 from "./MusicButtons.vue?vue&type=style&index=0&id=55661063&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports